import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { CoreCommonModule } from '@core/common.module';
import { MenuModule } from 'app/layout/components/menu/menu.module';
import { IconsModule } from 'app/components/icons';

import { HomeHeaderComponent } from './home-header.component';

@NgModule({
  declarations: [HomeHeaderComponent],
  imports: [
    RouterModule,
    FormsModule,
    NgbModule,
    TranslateModule,
    CoreCommonModule,
    MenuModule,
    // Los iconos del menú elegidos del catálogo se dibujan con <app-lucide-icon>
    IconsModule
  ],
  exports: [HomeHeaderComponent]
})
export class HomeHeaderModule {}
